/**
 * Entity Explorer Modal - MUI sx styles
 */

export const styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    p: 0,
    height: 'calc(100vh - 120px)',
    maxHeight: '1000px',
  },

  mainContent: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: 2,
    flex: 1,
    overflow: 'hidden',
    p: 2,
  },

  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    overflow: 'hidden',
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
  },

  tableContent: {
    flex: 1,
    overflow: 'auto',
    borderTop: '1px solid #e0e0e0',
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '300px',
  },

  emptyState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '300px',
    color: '#999',
    fontSize: '0.875rem',
  },

  infoPanelContainer: {
    border: '1px solid #e0e0e0',
    borderRadius: '4px',
    p: 2,
    overflow: 'auto',
    backgroundColor: '#fafafa',
  },

  infoPanelEmpty: {
    color: '#999',
    fontSize: '0.875rem',
    textAlign: 'center',
    py: 3,
  },

  infoPanelField: {
    mb: 2,
    pb: 1.5,
    borderBottom: '1px solid #e0e0e0',

    '&:last-child': {
      mb: 0,
      pb: 0,
      borderBottom: 'none',
    },
  },

  infoPanelLabel: {
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    color: '#666',
    mb: 0.5,
    display: 'block',
  },

  infoPanelValue: {
    fontSize: '0.875rem',
    color: '#333',
    wordBreak: 'break-word',
  },

  tableRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr auto',
    gap: 1,
    alignItems: 'center',
    px: 2,
    py: 1,
    borderBottom: '1px solid #f0f0f0',
    '&:hover': {
      backgroundColor: '#f9f9f9',
    },
  },

  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr auto',
    gap: 1,
    alignItems: 'center',
    px: 2,
    py: 1.5,
    backgroundColor: '#f0f0f0',
    fontWeight: 600,
    fontSize: '0.875rem',
    borderBottom: '2px solid #ddd',
    position: 'sticky',
    top: 0,
  },

  tableCell: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '0.875rem',
  },

  folderIcon: {
    mr: 0.5,
    fontSize: '0.875rem',
  },

  actionButtonGroup: {
    display: 'flex',
    gap: 0.5,
  },

  importButton: {
    fontSize: '0.75rem',
    py: 0.5,
    px: 1,
  },
};
